import { CompanyResult, DetailedDisplaysResult } from "models/StatisticsReport";
import generateBackgroundColors from "utility/generateBackgroundColors";
import LineChart from "../Charts/LineChart";
import { useParams } from "react-router-dom";

interface DetailedDisplaysProps {
    data: DetailedDisplaysResult;
    company: CompanyResult;
}

const DetailedDisplays = ({data, company}:DetailedDisplaysProps) => {
    let params = useParams();
    const chartLabels = data.companyData.map((element) => element.name);
    const {baseColorsFormatted} = generateBackgroundColors();
    const url = 'https://www.1881.no/tlf/mkas_' + params.id;
    const total = new Intl.NumberFormat('nb-NO').format(data.companyData.reduce((sum, element) => sum + element.count, 0));
    const chartSet = [
        {
            label: company.name,
            data: data.companyData.map((element) => element.count),
            backgroundColor: baseColorsFormatted[0],
            borderColor: baseColorsFormatted[0]
        },
        {
            label: "Snitt bransje",
            data: data.businessAverageData.map((element) => element.count),
            backgroundColor: baseColorsFormatted[1],
            borderColor: baseColorsFormatted[1]
        }
    ];

    return (
        <div className="card mb-4">
            <div className="card-header">
                <h2><big className="fw-bold">{total}</big> visninger av din bedrifts <a href={url}>infoside</a></h2>
            </div>
            <div className="card-body">
                <LineChart labels={chartLabels} datasets={chartSet} />
                <p className="mb-0 text-muted"><small>Bransje: {data.businessArea} i {data.tradeArea}</small></p>
            </div>
        </div>
    );
}

export default DetailedDisplays;